<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <div class="text-center">
                <div class="mb-0 flex justify-center">
                    <jet-application-mark class="h-9 w-auto" />
                </div>
            </div>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <div class="text-center">
                    <div class="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                        <p class="text-sm text-green-800">
                            <font-awesome-icon :icon="['fas', 'info-circle']" class="mr-2" />
                            This invitation has already been accepted.
                        </p>
                    </div>

                    <p class="text-gray-600 mb-4">
                        The invitation to join <strong>{{ invitation.organization.title }}</strong> 
                        was accepted on {{ new Date(invitation.accepted_at).toLocaleDateString() }}.
                    </p>

                    <div class="mt-6">
                        <a 
                            href="/login" 
                            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                        >
                            <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="mr-2" />
                            Sign In to TextSpot
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    invitation: Object,
});
</script>